<template>
    <div class="card-container">
        <common-top-form :model="formModel" @success="onSuccess" :submitService="submitService" :show="false"
                         :submitData="submitData">
                <select-organs v-model="formModel.tatSimpleId"></select-organs>
                <el-form-item label="结算类型">
                    <el-select v-model="formModel.closeType">
                        <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="结算日期">
                    <el-date-picker
                        v-model="formModel.time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatName" label="机构简称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="closeType" label="结算类型" :formatter="formatAdjTypee" min-width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="qpayAmt" label="快捷金额（元）" min-width="130" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.qpayAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="repayAmt" label="还款金额（元）" min-width="130" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.repayAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            v
            <el-table-column prop="lvUpAmt" label="升级金额（元）" min-width="130" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.lvUpAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="ufAmt" label="联创分润（元）" min-width="130" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.ufAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="totalAmt" label="结算总金额（元）" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.totalAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="totalSum" label="变动后余额（元）" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.totalSum *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="closeTime" label="结算日期" min-width="160"></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'

    import FinanceService from 'service/FinanceService'
    import OrganService from 'service/OrganService'

    import privateKey from 'service/constant/privateKey';
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'
    import TimeRange from 'service/constant/TimeRange'

    export default {
        name: "SettlementDetail",
        components: {
            CommonTopForm, CommonTable, SelectOrgans
        },
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    closeType: '',
                    time: TimeRange.dayRange,
                },
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                types: [{
                    value: '',
                    label: '全部'
                }, {
                    value: '1',
                    label: '手动'
                }, {
                    value: '2',
                    label: '自动'
                },],
                tableData: [],
                params: {},
                page: {},
                isPage: false,
                submitService: FinanceService.dtlList
            }
        },
        mixins: [loadMixin, dialogMixin],
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getList();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                this.params = {
                    userId: this.userId,
                    simpleTatId: this.formModel.tatSimpleId,
                    closeType: this.formModel.closeType,
                    beginTime: this.formModel.time[0],
                    endTime: this.formModel.time[1],
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };

                if (this.formModel.time.length == 0) {
                    delete this.params.beginTime;
                    delete this.params.endTime;
                }

                return this.params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId']),
        },
        methods: {
            formatAdjTypee(row, column, cellValue) {
                let value = '';
                this.types.forEach(item => {
                    if (item.value == cellValue) {
                        value = item.label;
                    }
                });
                return value ? value : '--';
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(FinanceService.dtlList, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(data) {
                const result = data.contents;
                this.tableData = result.rows;
                this.page.currentPage = result.current;
                this.page.total = result.total;
                this.page.pageSize = result.size;
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/SettlementDetail.vue